module.exports = __webpack_public_path__ + "img/流体力学2_2.b1a4d849.jpg";